import type { Property } from "@/types/property";

interface PropertyInfoProps {
  property: Property;
}

export const PropertyInfo = ({ property }: PropertyInfoProps) => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-2">{property.title}</h3>
      <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
        {property.description}
      </p>
      <div className="flex items-center gap-4 text-sm text-muted-foreground">
        <span>{property.bedrooms} beds</span>
        <span>{property.bathrooms} baths</span>
        <span>{property.max_guests} guests</span>
      </div>
      <p className="text-sm text-muted-foreground mt-2">
        {property.address}, {property.city}, {property.state}
      </p>
      <div className="mt-2">
        <span className="text-2xl font-bold">${property.price_per_night}</span>
        <span className="text-muted-foreground"> / night</span>
      </div>
    </div>
  );
};